export default __webpack_public_path__ + "static/media/pool.5f626c13.png";